/**
 * Universal PDP - UI Components
 * Handles product accordion and related products carousel
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize Product Accordion
  initializeProductAccordion();
  
  // Initialize More Support Products Swiper
  initMoreSupportSwiper();
  
  // Initialize Add to Cart for Related Products
  initializeRelatedProductsAddToCart();
  
  // Initialize Rating Click to Scroll to Reviews
  initializeRatingScrollToReviews();
  
  // Initialize Sticky Add to Cart Bar (show when buy box is in view)
  initializeStickyAddToCart();
});

/**
 * Initialize Product Accordion
 */
function initializeProductAccordion() {
  const accordionItems = document.querySelectorAll('[data-accordion-trigger]');
  
  accordionItems.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const content = document.getElementById(this.getAttribute('aria-controls'));
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      // Close all other accordion items
      accordionItems.forEach(otherTrigger => {
        if (otherTrigger !== this) {
          otherTrigger.setAttribute('aria-expanded', 'false');
          otherTrigger.classList.remove('product-accordion__header--active');
          const otherContent = document.getElementById(otherTrigger.getAttribute('aria-controls'));
          otherContent.classList.remove('product-accordion__content--active');
          
          // Reset icons for other accordions
          const otherPlusIcon = otherTrigger.querySelector('.product-accordion__icon-plus');
          const otherMinusIcon = otherTrigger.querySelector('.product-accordion__icon-minus');
          if (otherPlusIcon && otherMinusIcon) {
            otherPlusIcon.style.display = 'block';
            otherMinusIcon.style.display = 'none';
          }
        }
      });
      
      // Toggle current accordion item
      this.setAttribute('aria-expanded', !isExpanded);
      
      // Get icons for current accordion
      const plusIcon = this.querySelector('.product-accordion__icon-plus');
      const minusIcon = this.querySelector('.product-accordion__icon-minus');
      
      if (!isExpanded) {
        this.classList.add('product-accordion__header--active');
        content.classList.add('product-accordion__content--active');
        
        // Show minus icon, hide plus icon
        if (plusIcon && minusIcon) {
          plusIcon.style.display = 'none';
          minusIcon.style.display = 'block';
        }
      } else {
        this.classList.remove('product-accordion__header--active');
        content.classList.remove('product-accordion__content--active');
        
        // Show plus icon, hide minus icon
        if (plusIcon && minusIcon) {
          plusIcon.style.display = 'block';
          minusIcon.style.display = 'none';
        }
      }
    });
  });
}

/**
 * Initialize More Support Products Swiper
 */
function initMoreSupportSwiper() {
  const moreSupportSwiperElement = document.getElementById('moreSupportSwiper');
  
  if (!moreSupportSwiperElement) {
    return;
  }
  
  // Wait for Swiper to be loaded
  if (typeof Swiper === 'undefined') {
    setTimeout(initMoreSupportSwiper, 100);
    return;
  }
  
  const moreSupportSwiper = new Swiper('#moreSupportSwiper', {
    slidesPerView: 1, // Default for mobile
    spaceBetween: 16,
    loop: true,
    centeredSlides: false,
    autoHeight: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: '.more-support-pcos-relief__swiper-next',
      prevEl: '.more-support-pcos-relief__swiper-prev',
    },
    keyboard: {
      enabled: true,
    },
    a11y: {
      prevSlideMessage: 'Previous product',
      nextSlideMessage: 'Next product',
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 'auto',
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 16,
      }
    },
    on: {
      init: function() {
        this.update();
      }
    }
  });
}

/**
 * Initialize Add to Cart for Related Products
 */
function initializeRelatedProductsAddToCart() {
  const addToCartForms = document.querySelectorAll('.more-support-pcos-relief__add-form');
  
  addToCartForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const button = form.querySelector('.more-support-pcos-relief__add-button');
      const buttonText = button.querySelector('.btn-cta__text');
      if (!button || !buttonText) return;

      // Store original text
      const originalText = buttonText.textContent;
      
      // Show loading state
      buttonText.textContent = 'Adding to cart';
      button.disabled = true;
      
      // Add to cart via AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Success
        buttonText.textContent = 'Added to cart';
        button.style.background = '#28a745'; // Green
        
        // Update cart count
        updateCartCount();
        
        // Reset after 2 seconds
        setTimeout(function() {
          buttonText.textContent = originalText;
          button.style.background = '#E51550';
          button.disabled = false;
        }, 2000);
      })
      .catch(error => {
        // Error
        buttonText.textContent = 'Error';
        button.style.background = '#dc3545'; // Red
        
        // Reset after 2 seconds
        setTimeout(function() {
          buttonText.textContent = originalText;
          button.style.background = '#E51550';
          button.disabled = false;
        }, 2000);
        
        console.error('Error adding product to cart:', error);
      });
    });
  });
}

/**
 * Update Cart Count Without Opening Drawer
 */
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update all cart count elements
      const countElements = document.querySelectorAll('[data-count]');
      countElements.forEach(element => {
        element.textContent = cart.item_count;
      });
      
      // Update cart containers if they exist
      const cartContainers = document.querySelectorAll('[data-cart-container]');
      cartContainers.forEach(container => {
        if (container.dataset.cartSettings === 'count') {
          const countElement = container.querySelector('[data-count]');
          if (countElement) {
            countElement.textContent = cart.item_count;
          }
        }
      });
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

/**
 * Initialize Rating Click to Scroll to Reviews
 */
function initializeRatingScrollToReviews() {
  const ratingElement = document.getElementById('pdpRating');
  const reviewsSection = document.getElementById('reviews');
  
  if (!ratingElement || !reviewsSection) {
    return;
  }
  
  // Make rating clickable and scroll to reviews
  ratingElement.addEventListener('click', function(e) {
    e.preventDefault();
    
    // Calculate header heights for proper offset
    const allHeaders = document.querySelectorAll('header, .header, .site-header, [id*="header"], [class*="header"]');
    const announcementBar = document.querySelector('.announcement-bar, .top-bar, [class*="announcement"]');
    
    let totalHeaderHeight = 0;
    
    allHeaders.forEach(header => {
      const styles = window.getComputedStyle(header);
      if (styles.position === 'fixed' || styles.position === 'sticky') {
        totalHeaderHeight = Math.max(totalHeaderHeight, header.offsetHeight);
      }
    });
    
    if (announcementBar) {
      const styles = window.getComputedStyle(announcementBar);
      if (styles.position === 'fixed' || styles.position === 'sticky') {
        totalHeaderHeight += announcementBar.offsetHeight;
      }
    }
    
    // Default header height if none found
    if (totalHeaderHeight === 0) totalHeaderHeight = 80;
    
    const offset = 20; // Extra spacing
    const elementPosition = reviewsSection.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - totalHeaderHeight - offset;
    
    // Smooth scroll to reviews section
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  });
  
  // Also handle clicks on the rating link specifically
  const ratingLink = ratingElement.querySelector('.pdp-details__rating-link');
  if (ratingLink) {
    ratingLink.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation(); // Prevent double-trigger from parent
      
      // Trigger the parent's click event
      ratingElement.click();
    });
  }
}

/**
 * Initialize Sticky Add to Cart Bar (mobile)
 * Inline ATC lives in #pdp-buy-box inside .pdp-details. Fixed bar appears only after
 * the user scrolls past that buy box (entire box above viewport).
 */
function initializeStickyAddToCart() {
  const stickyBar = document.querySelector('.pdp-sticky-bar');
  const buyBox = document.getElementById('pdp-buy-box');

  if (!stickyBar || !buyBox) {
    return;
  }

  stickyBar.classList.remove('pdp-sticky-bar--visible');

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function checkBuyBoxVisibility() {
    if (!isMobile()) {
      stickyBar.classList.remove('pdp-sticky-bar--visible');
      stickyBar.setAttribute('aria-hidden', 'true');
      return;
    }

    const rect = buyBox.getBoundingClientRect();
    var scrolledPastBuyBox = rect.bottom <= 0;

    if (scrolledPastBuyBox) {
      stickyBar.classList.add('pdp-sticky-bar--visible');
      stickyBar.setAttribute('aria-hidden', 'false');
    } else {
      stickyBar.classList.remove('pdp-sticky-bar--visible');
      stickyBar.setAttribute('aria-hidden', 'true');
    }
  }

  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        checkBuyBoxVisibility();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', checkBuyBoxVisibility);
  checkBuyBoxVisibility();
}

